<script lang="ts">
  import { onMount } from 'svelte';
  import { AbTestService } from '@centerhealth/fe/abtest';
  import { CenterImage } from '@centerhealth/fe/center-kit';
  import { createSource, ISrcSetData } from '@centerhealth/fe/images';
  // Models
  import type { CtaModel } from '@centerhealth/fe/center-kit';
  // Components
  import { Button, StoreButton } from '@centerhealth/fe/center-kit';
  //Intersection Observer Wrapper

  const cta: CtaModel = {
    label: 'Get started now ➡️',
    link: '/signup',
  };

  const videoObjects: ISrcSetData[] = [
    {
      sourceUrl: '/assets/videos/features-hero.webm',
    },
    {
      sourceUrl: '/assets/videos/features-hero.mp4',
    },
  ];

  onMount(async () => {
    // A/B test cta in /features
    const featuresCtaVariation = await AbTestService.getVariation('featureCta_22-08-24');
    if (featuresCtaVariation === 'linkSubscribe') {
      cta.link = '/subscribe';
    }
  });
</script>

<section class="pt-7 pb-4 xl:pb-0 xl:py-7 xl:overflow-hidden xxl:pt-9">
  <div class="container-override">
    <h1 class="title-override text-gray-darkest">
      This is Center,
      <br />
      <span class="font-semibold">the last diabetes app you'll ever need </span>
    </h1>
    <div class="demo-override -z-10">
      <CenterImage>
        <video playsinline autoplay muted loop>
          <source src={createSource(videoObjects[0].sourceUrl)} type="video/webm" />
          <source src={createSource(videoObjects[1].sourceUrl)} type="video/mp4" />
        </video>
      </CenterImage>
    </div>
    <div
      class="mt-7 xl:mt-0 xl:col-start-1 xl:col-end-7 xl:row-start-3 xl:row-end-5 xxl:pl-3 mobile-full"
    >
      <Button
        mobileBlock
        heapAttr={{ action: 'cta', subAction: 'signup', sectionName: 'hero' }}
        size="medium"
        href={cta.link}>{cta.label}</Button
      >
    </div>
    <p
      class="m-5 text-gray text-lg xl:col-start-1 xl:col-end-7 xl:row-start-4 xl:m-0 xl:self-end xl:text-xl xxl:pl-3"
    >
      Get the app
    </p>
    <div class="store-override">
      <StoreButton type="app-store" />
      <StoreButton type="google-play" />
    </div>
  </div>
</section>

<style lang="scss">
  section {
    width: 100%;
    background-repeat: no-repeat;
    background-size: 700% auto;
    background-position: center bottom;
    @screen sm {
      background-size: 300% auto;
    }
    @screen lg {
      background-size: 200% auto;
    }
    @screen xl {
      background-size: 110% auto;
    }
  }
  .container-override {
    @apply container overflow-hidden grid grid-cols-1 place-items-center mx-auto relative;
    @screen xl {
      max-height: 550px;
      @apply xl:grid-cols-12 xl:grid-rows-6 xl:justify-items-start xl:items-center;
    }
    @screen xxl {
      max-height: 650px;
    }
  }

  .demo-override {
    transform: scale3d(1.8, 1.8, 1.8);
    @apply mt-7;

    // Changing the size of the demo across different breakpoints
    @screen md {
      transform: scale3d(1.5, 1.5, 1.5);
    }
    @screen xl {
      transform: scale3d(1.8, 1.8, 1.8);
      @apply xl:mt-0 xl:absolute xl:row-start-1 xl:row-end-7 xl:col-start-7 xl:col-end-13 xl:justify-self-center xl:top-32;
    }
  }
  .title-override {
    @apply text-center mb-3 md:mx-8;

    @screen xl {
      @apply xl:text-left xl:col-start-1 xl:col-end-7 xl:row-start-2 xl:row-end-3 xl:mb-5 xl:mx-0;
    }
    @screen xxl {
      @apply xxl:col-end-5 xxl:col-end-7 xxl:pl-3;
    }
  }

  .store-override {
    // Mobile first, Vertical layout for stores buttons
    @apply flex flex-col items-center;
    // Small first, Horizontal layout for stores buttons
    @apply sm:flex-row sm:justify-center sm:gap-3;
    // Large set the position of the stores buttons to the left of the grid
    @apply xl:col-start-1 xl:col-end-7 xl:row-start-5 xl:justify-start;
    @apply xxl:pl-3;
  }

  .mobile-full {
    @media (max-width: 768px) {
      @apply w-full;
    }
  }
</style>
